// extracted by mini-css-extract-plugin
export default {"container":"style_container__b4rg2","title":"style_title__mDyTC","title_small":"style_title_small__-R-8t"};